import { apiClient } from '@/api/client'
import type {
  FlashcardCreateRequest,
  FlashcardGenerateRequest,
  FlashcardGenerateResponse,
  FlashcardResponse,
  FlashcardReviewRequest,
  FlashcardReviewResponse,
  FlashcardStatsResponse,
} from '@/api/types/flashcard'

export const createFlashcard = async (request: FlashcardCreateRequest): Promise<FlashcardResponse> => {
  const res = await apiClient.post('/flashcards', request)
  return res.data
}

export const getFlashcards = async (episodeId?: number): Promise<FlashcardResponse[]> => {
  const params = episodeId ? { episode_id: episodeId } : {}
  const res = await apiClient.get('/flashcards', { params })
  return res.data
}

export const deleteFlashcard = async (id: number): Promise<void> => {
  await apiClient.delete(`/flashcards/${id}`)
}

export const getReviewCards = async (): Promise<FlashcardResponse[]> => {
  const res = await apiClient.get('/flashcards/review')
  return res.data
}

export const reviewFlashcard = async (
  id: number,
  request: FlashcardReviewRequest,
): Promise<FlashcardReviewResponse> => {
  const res = await apiClient.post(`/flashcards/${id}/review`, request)
  return res.data
}

export const getFlashcardStats = async (): Promise<FlashcardStatsResponse> => {
  const res = await apiClient.get('/flashcards/stats')
  return res.data
}

export const generateFlashcard = async (request: FlashcardGenerateRequest): Promise<FlashcardGenerateResponse> => {
  const res = await apiClient.post('/flashcards/generate', request)
  return res.data
}
